<template>
  <v-container>
    <v-row>
      <div class="d-flex title-row logout-btn-row">
        <v-btn
          outlined
          @click="logout()"
        >Kijelentkezés</v-btn>
      </div>
      <div class="d-flex justify-center title-row">
        <h2>Aktuális</h2>
      </div>

      <!-- LIST -->

      <v-col
        cols="12"
        lg="4"
        class="d-flex justify-center"
      >
        <v-card
          class="mx-auto"
          min-width="400"
          tile
        >
          <v-list-item
            two-line
            v-for="(item, idx) in actual"
            :key="idx"
            @click="selectItem(item)"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.Location }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.ImgFolder }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>

      <!-- FORM -->

      <v-col
        cols="12"
        lg="8"
        class="d-flex justify-center"
      >
        <v-form
          ref="form"
          v-model="valid"
          class="form"
        >
          <v-text-field
            v-model="actualForm.Price"
            :rules="requiredRules"
            :label="'Ár'"
            required
          ></v-text-field>
          <v-text-field
            v-model="actualForm.Handover"
            :rules="requiredRules"
            :label="'Átadás dátuma'"
            required
          ></v-text-field>
          <v-text-field
            v-model="actualForm.Location"
            :rules="requiredRules"
            :label="'Helyszín'"
            required
          ></v-text-field>
          <v-text-field
            v-model="actualForm.Size"
            :rules="requiredRules"
            :label="'Méret'"
            required
          ></v-text-field>
          <v-text-field
            v-model="actualForm.ImgFolder"
            :rules="requiredRules"
            :label="'Képek könyvtárának neve'"
            required
          ></v-text-field>
          <v-textarea
            v-model="actualForm.Info"
            name="input-7-1"
            :label="'Leírás'"
            :rules="requiredRules"
          ></v-textarea>
          <v-checkbox
            v-model="actualForm.ForRent"
            label="Kiadásra is"
            required
          ></v-checkbox>
          <div>
            <v-btn
              outlined
              class="white--text"
              v-on:click.native="clearActualForm"
            >Új létrehozása</v-btn>
            <v-btn
              outlined
              class="white--text"
              :disabled="!valid"
              :loading="loadingAnimation"
              v-on:click.native="addActual"
            >Feltöltés</v-btn>
            <v-btn
              outlined
              class="red--text"
              :disabled="!valid"
              :loading="loadingAnimation"
              v-on:click.native="deleteActual"
            >Törlés</v-btn>
          </div>
        </v-form>
        <v-snackbar
          v-model="successSnackbar"
          color="snackbar-success"
        >
          Siker!
        </v-snackbar>
        <v-snackbar
          v-model="errorSnackbar"
          color="error"
        >
          Hiba történt!
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import firebase from "firebase/app";
import "@firebase/auth";
import { db } from "@/main";

export default {
  data() {
    return {
      valid: false,
      successSnackbar: false,
      errorSnackbar: false,
      loadingAnimation: false,
      requiredRules: [v => !!v || "Kötelező"],
      actual: [],
      actualForm: {
        Handover: "",
        ImgFolder: "",
        Info: "",
        Location: "",
        Size: "",
        ForRent: false,
        Price: "",
        id: ""
      }
    };
  },
  firestore() {
    return { actual: db.collection("Actual") };
  },
  methods: {
    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("login");
        });
    },
    addActual() {
      console.log("Actualform submitted", this.actualForm);
      db.collection("Actual")
        .add({
          Handover: this.actualForm.Handover,
          ImgFolder: this.actualForm.ImgFolder,
          Info: this.actualForm.Info,
          Location: this.actualForm.Location,
          Size: this.actualForm.Size,
          ForRent: this.actualForm.ForRent,
          Price: this.actualForm.Price
        })
        .then(
          res => {
            this.successSnackbar = true;
            this.clearActualForm();
            // console.log("Done: ", res);
          },
          err => {
            this.errorSnackbar = true;
            console.log("error happened: ", err);
          }
        );
    },
    selectItem(item) {
      this.actualForm.Handover = item.Handover;
      this.actualForm.ImgFolder = item.ImgFolder;
      this.actualForm.Info = item.Info;
      this.actualForm.Location = item.Location;
      this.actualForm.Size = item.Size;
      this.actualForm.ForRent = item.ForRent;
      this.actualForm.Price = item.Price;
      this.actualForm.id = item.id;
    },
    clearActualForm() {
      (this.actualForm.Handover = ""),
        (this.actualForm.ImgFolder = ""),
        (this.actualForm.Info = ""),
        (this.actualForm.Location = ""),
        (this.actualForm.Size = "");
        (this.actualForm.Price = "");
        (this.actualForm.ForRent = false);
    },
    deleteActual() {
      db.collection("Actual")
        .doc(this.actualForm.id)
        .delete();
      this.clearActualForm();
    }
  }
};
</script>

<style scoped>
.form {
  width: 750px;
}
.title-row {
  width: 100%;
}
.logout-btn-row {
  justify-content: flex-end;
  margin-right: 2rem;
}
.v-list-item__content {
  cursor: pointer;
}
.v-btn {
  margin-left: 10px;
  margin-top: 20px;
}
</style>